import React from "react";
import styled from "styled-components";

const Td = styled.td`
  padding-right: 30px;
  font-size: 8pt;
  color: #888;
`;

export default function SampleStatusKey(props) {
  return (
    <div>
      <table>
        <tbody>
          <tr>
            <Td>
              <b>P</b> : {I18n.t('preliminary_sample')}
            </Td>
            <Td>
              <b>U</b> : {I18n.t('unreceived_sample')}
            </Td>
            <Td>
              <i className="fa fa-check" /> : {I18n.t('fully_reviewed_sample')}
            </Td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
